import { accountConstants } from "../constants";
import { FETCH_ALL_LEDGER_FAILED, FETCH_ALL_LEDGER_PENDING, FETCH_ALL_LEDGER_SUCCESS, GET_ALL_LEDGER_CURRENCY, GET_ALL_LEDGER_PAYMENT_MODE_LIST, GET_ALL_LEDGER_STATUS_LIST, GET_ALL_LEDGER_TRANSACTION_MODE, GET_ALL_LEDGER_TRANSACTION_TYPE, GET_SELLER_LEDGER_TOTALS_PENDING, GET_SELLER_LEDGER_TOTALS_SUCCESS } from "../types";

const initialState = {
    showAccountingMenu: false,
    ledgerData: {},
    ledgerListStatus: '',
    transactionsModeList: [],
    transactionTypeList: [],
    ledgerCurrencyList: [],
    ledgerPaymentModeList: [],
    ledgerStatusList: [],
    sellerLedgerList: [],
    sellerLedgerListStatus: '',
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action = '') {
    const { type, payload } = action;
    switch (type) {
        case accountConstants.SHOW_ACCOUNTING_MENU:
            return {
                ...state,
                showAccountingMenu: payload
            };
        case FETCH_ALL_LEDGER_PENDING:
            return {
                ...state,
                ledgerData: {},
                ledgerListStatus: 'PENDING',
            };
        case FETCH_ALL_LEDGER_SUCCESS:
            return {
                ...state,
                ledgerData: payload,
                ledgerListStatus: 'SUCCESS',
            };
        case FETCH_ALL_LEDGER_FAILED:
            return {
                ...state,
                ledgerData: {},
                ledgerListStatus: 'FAILED',
            };
        case GET_ALL_LEDGER_TRANSACTION_MODE:
            return {
                ...state,
                transactionsModeList: payload,
            };
        case GET_ALL_LEDGER_TRANSACTION_TYPE:
            return {
                ...state,
                transactionTypeList: payload,
            };
        case GET_ALL_LEDGER_CURRENCY:
            return {
                ...state,
                ledgerCurrencyList: payload,
            };
        case GET_ALL_LEDGER_PAYMENT_MODE_LIST:
            return {
                ...state,
                ledgerPaymentModeList: payload,
            };
        case GET_ALL_LEDGER_STATUS_LIST:
            return {
                ...state,
                ledgerStatusList: payload,
            };
        case GET_SELLER_LEDGER_TOTALS_PENDING:
            return {
                ...state,
                sellerLedgerList: [],
                sellerLedgerListStatus: 'PENDING',
            };
        case GET_SELLER_LEDGER_TOTALS_SUCCESS:
            return {
                ...state,
                sellerLedgerList: payload,
                sellerLedgerListStatus: 'SUCCESS',
            };
        default:
            return state;
    }
}
